import type { RouteObject } from "react-router"
import { createBrowserRouter, Navigate, RouterProvider } from "react-router"
import { CallbackPage } from "@/domains/login/pages/CallbackPage/CallbackPage"
import { LoginPage } from "@/domains/login/pages/LoginPage/LoginPage"

export function UnauthenticatedRouter() {
  const routes: RouteObject[] = [
    {
      path: "/",
      element: <LoginPage />
    },
    {
      path: "/login",
      element: <LoginPage />
    },
    {
      path: "/auth/callback",
      element: <CallbackPage />
    },
    {
      path: "*",
      element: (
        <Navigate
          to={`/login?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`}
          replace
        />
      )
    }
  ]

  return <RouterProvider router={createBrowserRouter(routes)} />
}
